import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import style from './ProfileSidebar.module.css';

const menuItems = [
  {
    title: 'Мои данные',
    page: 'edit-profile',
  },
  {
    title: 'Мои адреса',
    page: 'addresses',
  },
  {
    title: 'Банковские карты',
    page: 'saved-cards',
  },
  {
    title: 'Мои заказы',
    page: 'orders',
  },
  {
    title: 'История икринок',
    page: 'bonus',
  },
];

type ProfileSidebarProps = {
  currentPage: string | null;
};

export const ProfileSidebar = ({ currentPage }: ProfileSidebarProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <aside className={style.sidebar}>
      {menuItems.map((item) => (
        <button
          key={item.page}
          type="button"
          onClick={() => navigate(`/profile?page=${item.page}`)}
          className={clsx(
            style.menuItem,
            currentPage === item.page && style.active,
          )}
        >
          {t(item.title)}
        </button>
      ))}
    </aside>
  );
};